<template>
  <div>
    <div style="text-align: center; height: 100vh; vertical-align: middle">
      <img style="margin: auto" width="100" height="100" src="@/assets/logo.png" alt="正在登陆">
    </div>
    <el-dialog :visible.sync="doBind">
      <user-bind-form :open-id="openId"></user-bind-form>
    </el-dialog>
  </div>
</template>

<script>

import {mapGetters} from "vuex";

import Http from "@/lib/Http"
import UserBindForm from "@/components/user/UserBindForm";

const redirectUrl = encodeURIComponent("http://search.xazenith.com/#/wechat/login")

export default {
  name: "WeChatLoginPage",
  components: {UserBindForm},
  data() {
    return {
      doBind: false,
      openId: ''
    }
  },
  mounted() {
    if (this.user.isLogined()) {
      this.$router.push("/")
    } else {
      const code = this.$route.query.code
      if (code) {
        Http.get(`http://m.xazenith.com/api/wechat/check/code?code=${code}`).then(resp => {
          if (resp.state === 200) {
            if (resp.data.state === 'success') {
              this.$router.push("/")
            } else if (resp.data.nextAction === 'registry') {
              this.doBind = true
              this.openId = resp.data.openId
            }
          }
        })
      } else {
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appId=wx4ad78f0aafc4c9a2&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base&state=302#wechat_redirect`
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'currentUser'
    })
  }
}
</script>

<style scoped>

</style>
